// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"278a96ee","637":"2fe26e82","763":"a0ad3f78"}[chunkId] + ".chunk.css";
};